var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-app overflow-hidden flex flex-col justify-stretch"},[_c('div',{staticClass:"flex-grow overflow-hidden flex flex-col justify-stretch"},[_c('Specification',{attrs:{"height":"h-full w-full"},on:{"close":_vm.close}})],1),_vm._v(" "),_c('div',{staticClass:"h-14 flex-none"})])
}
var staticRenderFns = []

export { render, staticRenderFns }